import React from 'react'
import classNames from 'classnames'
import DatePicker from '../../datePicker'
import './index.less'

export default ({ onChange, startTime, endTime, required, ...props }) => {
  const _onChange = ([_startTime, _endTime]) => {
    onChange?.([_startTime, _endTime])
  }

  return <DatePicker
    wrapperClassName={classNames('mn-input-select-date-picker-wrapper', { required })}
    className="mn-input-select-date-picker"
    textStyle={{ flex: '1', color: `${!startTime ? 'var(--m-text-4)' : 'var(--m-text-1)'}` }}
    startTime={startTime}
    endTime={endTime}
    onChange={_onChange}
    {...props}
  />
}
